module.exports = __webpack_public_path__ + "static/media/codeRule1.3b6535be.png";